<template>
<v-app>
  <v-expansion-panels :value="0">
    <v-expansion-panel
      v-for="(item,i) in content"
      :key="i"
    >
      <v-expansion-panel-header>
          {{ item.title }}
      </v-expansion-panel-header>

      <v-expansion-panel-content>
        <div v-if="!item.content_right" v-html="item.content"></div>
        <div v-else class="wp-block-columns is-style-11-11">
            <div class="wp-block-column" v-html="item.content"></div>

            <div class="wp-block-column" v-html="item.content_right"></div>
        </div>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
</v-app>
</template>

<script>
export default {
  name: "Accordion",

  computed: {
    content() {
      return this.$root.content;
    }
  },
}
</script>
